import { Component, OnInit } from '@angular/core';
import {  MatDialogRef } from '@angular/material/dialog';
import { CommonFunctions } from '../../common-functions';
declare var dataLayer;
@Component({
  selector: 'app-force-logout-dialog',
  templateUrl: './force-logout-dialog.component.html',
  styleUrls: ['./force-logout-dialog.component.scss']
})
export class ForceLogoutDialogComponent{
  userType: string;
  userId: any;
  tierType: any;
  constructor(  private dialogRef: MatDialogRef<ForceLogoutDialogComponent>,
    private commonFunction: CommonFunctions) {
    this.userType = this.commonFunction.getUserType();
    this.userId = this.commonFunction.getUserId();
    this.tierType = this.commonFunction.getTierType();
   }
  closeDialog(value) {
    this.dialogRef.close(value);
  }
  crossBtnGA(){
    dataLayer.push({
      'event':'cross_click',
      'userID':this.userId,
      'user_type':this.userType,
      'tier':this.tierType
    })
  }
}
